import React, { useState, useEffect } from "react";
import axios from "axios";
import { HiOutlineArrowRight, HiOutlineClock, HiTag } from "react-icons/hi2";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { baseurl, imgurl } from "../baseurl";

// Swiper Styles
import "swiper/css";
import "swiper/css/pagination";
import "../asset/css/packages.css";
import { Link } from "react-router-dom";

const AllPackages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle Resize for Slider Toggle
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${baseurl}/getAllPackages`);
        if (response.data.status === "success") {
          setPackages(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching packages:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPackages();
  }, []);

  if (loading) {
    return <div className="text-center py-5">Loading amazing deals...</div>;
  }

  // Common Card Content to avoid repetition
  const renderPackageCard = (pkg) => (
    <div className="package-card shadow-sm">
      <div className="package-img-wrapper">
        <img
          src={`${imgurl}/uploads/${pkg.banner_path}`}
          alt={pkg.package_name}
          className="package-img"
        />
        <div className="package-badge">{pkg.package_type}</div>
        <div className="package-price-tag">
          <span className="currency">₹</span>
          {parseFloat(pkg.price).toLocaleString()}
        </div>
      </div>

      <div className="package-content p-4">
        <div className="d-flex align-items-center mb-2 text-muted small">
          <HiOutlineClock className="me-1 text-teal" />
          <span>2 Days / 1 Night</span>
        </div>

        <h4 className="package-title mb-3">{pkg.package_name}</h4>

        <p className="package-desc text-muted mb-4">
          {pkg.package_description.substring(0, 80)}...
        </p>

        <div className="package-footer d-flex justify-content-between align-items-center pt-3 border-top">
          <div className="d-flex align-items-center text-teal fw-bold">
            <HiTag className="me-1" /> Best Price
          </div>
          <Link to={`/package/${pkg.id}`} className="btn-details">
            View Details <HiOutlineArrowRight className="ms-1" />
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <section className="popular-packages-section container py-5">
      <div className="section-header text-center mb-5">
        <h6 className="text-teal fw-bold letter-spacing-2 text-uppercase">
          Exclusive Offers
        </h6>
        <h2 className="display-5 fw-bold">Popular Tour Packages</h2>
        <div className="underline mx-auto"></div>
      </div>

      {isMobile ? (
        /* --- MOBILE SLIDER VIEW --- */
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1.2} // Shows a peek of the next card
          centeredSlides={true}
          loop={true}
          autoplay={{ delay: 3000 }}
          pagination={{ clickable: true }}
          className="mobile-package-swiper"
        >
          {packages.map((pkg) => (
            <SwiperSlide key={pkg.id}>
              {renderPackageCard(pkg)}
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        /* --- DESKTOP GRID VIEW --- */
        <div className="row g-4">
          {packages.map((pkg) => (
            <div className="col-lg-4 col-md-6" key={pkg.id}>
              {renderPackageCard(pkg)}
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default AllPackages;